import React from 'react';
import {
  ColorPalette,
  WidgetProps,
} from './types';
import styles from './styles.module.scss';
import classNames from 'classnames'
import { images } from '../../../../assets/image';

const TitleWidget: React.FC<WidgetProps> = (props: WidgetProps) => {
  const {
    widgetParams,
    defaultPaddings,
  } = props;

  const getTextColor = () => {
    const { textColor } = props.widgetParams;

    if (textColor === ColorPalette.primary) {

      return styles.primaryTitle;

    } else if (textColor === ColorPalette.onSurface) {

      return styles.onSurfaceTitle;

    } else {
      return styles.onSurfaceMidTitle;
    }
  }

  return (
    <div
      className={classNames([styles.TitleCard, getTextColor()])}
      style={defaultPaddings}
    >
      {props.widgetParams.title}
    </div>
  );
};

export default TitleWidget;
